import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentFY, getLastFYyears } from "../../../Utilitie";

import STAYardExFyearWise from "./STAYardExFyearWise";
import STAYardMWData from "./STAYardMWData";
import STAYardController from "./STAYardController";
const opState = {
  Year: false,
  Month: false,
};
const STAYardMaster = () => {
  const fys = getLastFYyears();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);

  const [fyYears, setFyYears] = useState([]);
  const [rawData, setRawData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedFy, setSelectedFy] = useState(
    getCurrentFY().replace("_", "-")
  );
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}staexaminationsick?FyYear=${selectedFy}`
        );

        if (response.status === "ok" && Array.isArray(response.data)) {
          setFyYears(response.previousFinancialYears);
          setData(response.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  return (
    <div className="">
      <div class="d-flex justify-content-end ">
        {/* <div className="col-md-8">
          <STAYardController
            data={data}
            setSelectedFilters={setSelectedFilters}
            setFilteredData={setFilteredData}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
        </div> */}
        <select
          className="form-select text-black fw-bolder text-center form-control w-25"
          onChange={(e) => {
            setSelectedFy(e.target.value);
          }}
        >
          <option value="" hidden>
            Select Financial Year
          </option>

          {fys.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>{" "}
      <div className="papaDiv ">
        <STAYardExFyearWise data={data} />
      </div>
      <div className="papaDiv ">
        <STAYardMWData data={data} />
      </div>
    </div>
  );
};
export default STAYardMaster;
